export const normalizeSearchText = (value) => String(value !== null && value !== void 0 ? value : '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
export const includesNormalizedSearch = (value, search) => normalizeSearchText(value).includes(normalizeSearchText(search));
export const filterNormalizedOptionLabel = (input, option) => includesNormalizedSearch(option === null || option === void 0 ? void 0 : option.label, input);
